<mobile-header class="md:hidden" />
<web-sidebar class="hidden md:flex" />
<main class="flex-1 overflow-y-auto px-4 pt-6 pb-28 md:pb-6">
  <div class="mx-auto w-full max-w-7xl">
    <router-outlet />
  </div>
</main>

<mobile-menu />
